import React from 'react';
import { CheckCircle } from 'lucide-react';
import { CoverageHero } from '../components/CoverageHero';
import { CoverageCTA } from '../components/CoverageCTA';

const Dental = () => {
  return (
    <div className="min-h-screen">
      <CoverageHero
        title="Dental Coverage That Helps Protect Your Smile and Your Budget"
        subtitle="Affordable dental plans for preventive care, basic and major services, and family coverage options. Coverage with purpose."
      />
      <section className="py-8">
        <div className="container mx-auto px-4"><div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-6">Why Dental Coverage Matters</h2>
            <p className="text-lg text-gray-700 leading-relaxed">Regular dental care is essential for overall health. Dental insurance helps make routine checkups, cleanings, and procedures more affordable.</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {[{title:"Preventive Care",desc:"Routine exams, cleanings, and X-rays often covered at 100%."},{title:"Basic Services",desc:"Coverage for fillings, extractions, and other common procedures."},{title:"Major Services",desc:"Coverage for crowns, bridges, dentures, root canals."}].map(item=>(<div key={item.title} className="bg-white border-t-4 border-brand-blue rounded-lg p-6 shadow-md text-center"><h3 className="text-xl font-bold text-brand-blue mb-3">{item.title}</h3><p className="text-gray-700">{item.desc}</p></div>))}
          </div>
        </div></div>
      </section>
      <section className="py-8 bg-gray-50">
        <div className="container mx-auto px-4"><div className="max-w-4xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-blue mb-8 text-center">Dental Plans for Every Stage of Life</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[{title:"Individual Dental Plans",desc:"Affordable options for individuals who need dental coverage."},{title:"Family Dental Plans",desc:"Cover the whole family with plans that include pediatric dental care."},{title:"Senior Dental Options",desc:"Dental coverage designed for seniors, including denture care."},{title:"Supplemental Dental",desc:"Add dental coverage to your existing health plan."}].map(item=>(<div key={item.title} className="flex items-start gap-4 bg-white p-6 rounded-lg shadow-md"><CheckCircle className="text-brand-orange flex-shrink-0 mt-1" size={24}/><div><h3 className="font-bold text-lg text-brand-blue mb-2">{item.title}</h3><p className="text-gray-700">{item.desc}</p></div></div>))}
          </div>
        </div></div>
      </section>
      <CoverageCTA heading="Compare Dental Plans" />
    </div>
  );
};

export default Dental;
